export const defaultNotificationOptionsSettingValue = {
    genericSensitiveMessageHint: 'You have a sensitive alert from APP. Please log in to AppURL to view your message.',
    secureMessageHint: 'Secure Message Hint',
    mandatoryChannels: [],
    messageType: 'Alert',
    availableForResponse: { max: 168, default: 8 },
    responseOption: 'Message received',
    voiceRepeatOptions: {
        voiceRepeatCall: 1,
        voiceRepeatDelay: 10,
    },
    escalationOptions: {
        voiceValues: [0, 5, 10, 15, 30, 60],
        voiceDefault: 30,
        textValues: [0, 5, 10, 15, 30, 60],
        textDefault: 5,
    },
    phinOptions: {
        //TODO phinOptions classifiers create ALS-1692
        urgencyOfEvent: ['Immediate', 'Expected', 'Future', 'Past', 'Unknown'],
        severityOfEvent: ['Extreme', 'Severe', 'Moderate', 'Minor', 'Unknown'],
        certaintyOfEvent: ['Observed', 'Likely', 'Possible', 'Unlikely', 'Unknown'],
        messageTypes: ['alert', 'cancel', 'update'],
        deliveryTime: [
            { value: 15, title: 'Within 15 minutes' },
            { value: 60, title: 'Within 60 minutes' },
            { value: 1440, title: 'Within 24 hours' },
            { value: 4320, title: 'Within 72 hours' },
        ],
        htmlMessageOptions: {
            product: 'Alert UI New',
            jurisdictionLevel: 'Local',
            productRole: 'Alert Documentation Coordinator',
        },
    },
};
